var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3638 5H10.6362C6.97687 5 4 7.97687 4 11.6362V40.3638C4 44.0231 6.97687 47 10.6362 47H39.3638C43.0231 47 46 44.0231 46 40.3638V11.6362C46 7.97687 43.0231 5 39.3638 5ZM41.5758 40.3638C41.5758 41.5834 40.5834 42.5758 39.3639 42.5758H10.6362C9.4166 42.5758 8.42435 41.5834 8.42435 40.3638V11.6362C8.42435 10.4166 9.41672 9.42435 10.6362 9.42435H39.3638C40.5834 9.42435 41.5756 10.4167 41.5756 11.6362V40.3638H41.5758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1484 17.4349C32.4349 17.4349 31.7643 17.713 31.2596 18.2178L21.3757 28.1178L18.7414 25.4837C18.237 24.9792 17.5664 24.7013 16.8531 24.7013C16.1397 24.7013 15.4691 24.9792 14.9646 25.4835C14.4603 25.9879 14.1826 26.6585 14.1826 27.3718C14.1826 28.0851 14.4603 28.7557 14.9646 29.2599L19.4878 33.7831C19.9922 34.2876 20.6628 34.5655 21.3762 34.5655C22.0892 34.5655 22.7601 34.2874 23.265 33.7826L35.0368 21.9939C36.0778 20.9526 36.0777 19.2583 35.0368 18.217C34.5324 17.7127 33.8617 17.4349 33.1484 17.4349Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.1a87c89a939d9be223263e8045444dcb.svg";
export { ForwardRef as ReactComponent };